import React from "react";
import ClientTestimonial from "../components/ClientTestimonial";
import faqImage from "../assets/images/faq_img.webp";
import absLaunch from "../assets/images/absLaunch.webp";
import whImg from "../assets/images/whImg.webp";
import fc1 from "../assets/images/fcs1.webp";
import fc2 from "../assets/images/fcs2.webp";
import Faq from "../components/Faq";
import MailBox from "../assets/icons/MailBox";
import Call from "../assets/icons/Call";
import Rightarrow from "../assets/icons/Rightarrow";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";



const About = () => {
  const { t } = useTranslation();
 let faqs = [
  { question: t("how_do_i_place_an_order_on_loadinn"), answer: t("to_place_an_order_log_in_select_restaurant_choose_items_checkout") },
  { question: t("can_i_order_from_multiple_restaurants_at_the_same_time"), answer: t("no_orders_must_be_placed_separately_for_each_restaurant") },
  { question: t("can_i_schedule_an_order_for_later"), answer: t("yes_you_can_schedule_an_order_for_a_later_time") },
  { question: t("what_payment_methods_are_accepted"), answer: t("we_accept_cards_apple_pay_google_pay_loadinn_wallet") },
  { question: t("are_there_any_hidden_charges"), answer: t("no_all_charges_are_displayed_before_confirming_the_order") },
  { question: t("can_i_add_a_tip_for_the_delivery_driver"), answer: t("yes_you_can_tip_the_driver_through_the_platform") },
  { question: t("how_can_i_track_my_order"), answer: t("you_can_track_your_order_via_website_or_tracking_email") },
  { question: t("can_i_contact_the_delivery_driver"), answer: t("yes_you_can_contact_the_driver_if_needed") },
  { question: t("what_if_my_delivery_is_delayed"), answer: t("we_try_to_deliver_as_soon_as_possible_contact_support_if_issue") },
  { question: t("can_i_cancel_my_order_after_placing_it"), answer: t("yes_but_cancellations_do_not_qualify_for_refund") },
  { question: t("under_what_conditions_can_i_get_a_refund"), answer: t("if_order_is_not_ready_after_one_hour_you_may_get_refund_contact_support_for_other_issues") },
  { question: t("how_long_does_refund_take"), answer: t("once_refund_is_approved_amount_is_credited_to_loadinn_wallet") },
  { question: t("do_i_need_an_account_to_place_an_order"), answer: t("yes_you_must_create_an_account_to_place_an_order") },
  { question: t("what_if_i_forget_my_password"), answer: t("you_can_reset_your_password_anytime_even_if_forgotten") },
  { question: t("how_can_i_contact_customer_support"), answer: t("you_can_contact_us_via_chat_support_on_our_website") },
];


  return (
    <React.Fragment>
      <section className="rest_banner about_banner">
        <div className="wrapper">
          <div className="rest_bntext">
            <h1>{t("about_us")}</h1>
          </div>
        </div>
      </section>

      <section className="wh_section">
        <div className="wrapper">
          <h2 className="subtitle_common">
            {t("who_we_are")} <span className="text-primary">{t("question_mark")}</span>
          </h2>
          <div className="client_main_grid wh_grd">
            <img src={whImg} alt={t("who_we_are_alt")} />
            <p className="para_common">{t("we_believe_food_is_more_than_meal")}</p>
          </div>
        </div>
      </section>

      <section className="fcstmr">
        <div className="wrapper">
          <div className="pricing_title">
            <h2 className="subtitle_common">{t("for_our_customers")}</h2>
            <p className="para_common">{t("customers_seek_quality_transparency")}</p>
          </div>
          <div className="cta_grid fcssgrid">
            <div className="fcs_grd_clmn">
              <img src={fc1} alt={t("customers_section1_img_alt")} />
              <p className="para_common">{t("customers_section1_text")}</p>
            </div>
            <div className="fcs_grd_clmn">
              <img src={fc2} alt={t("customers_section2_img_alt")} />
              <p className="para_common">{t("customers_section2_text")}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="abs_launch">
        <div className="wrapper">
          <div className="launch_section_grid">
            <div className="launch_img">
              <img src={absLaunch} alt={t("partner_restaurants_img_alt")} />
            </div>
            <div className="bg_image_yellow launch_content">
              <h2 className="subtitle_common">
                {t("for")} <span className="text-primary">{t("our_partner_restaurants")}</span>
              </h2>
              <p className="para_common">{t("restaurants_heart_of_community")}</p>
              <p className="para_common">{t("subscription_model_advantages")}</p>
              <p className="para_common">{t("financial_flexibility_for_restaurants")}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="community">
        <div className="wrapper">
          <div className="comm_bg">
            <div className="mx-width">
              <h2 className="subtitle_common text-secondary">{t("building_fairer_stronger_community")}</h2>
              <p className="para_common">{t("loadinn_more_than_platform")}</p>
              <p className="para_common">{t("future_every_meal_supports_local")}</p>
            </div>
          </div>
        </div>
      </section>

      <ClientTestimonial />

      <section className="bg_image_yellow bg_cta_scs">
        <div className="wrapper">
          <div className="bg_cta_scs_cont">
            <h2 className="subtitle_common">{t("get_started")}</h2>
            <p className="para_common">{t("get_started_text")}</p>
            <Link href="#" className="btn btn-secondary">
              {t("register_your_restaurant_now")} <Rightarrow />
            </Link>
          </div>
        </div>
      </section>

      <Faq faqs={faqs} faqimg={faqImage} />

      <section className="bg_image_yellow">
        <div className="wrapper">
          <div className="cta_grid">
            <div className="cta_title">
              <h2 className="subtitle_common">{t("need_help")}</h2>
              <p className="para_common">{t("need_help_text")}</p>
            </div>
            <div className="cta_buttons">
              <Link href="mailto:example@gmail.com" className="btn btn-primary">
                <MailBox /> {t("email_us")}
              </Link>
              <Link href="tel:9191919191" className="btn btn-primary">
                <Call /> {t("call_us")}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default About;
